import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getCounterpartyCustomersListService,
  getCustomerAccountsListService,
  counterpartyGetBranchCustomersService,
} from '../services/customers.service';
import { TCustomerAccountsListResData, TCustomersListReqParams, TCustomersListResData } from '../types/customers.types';

export const customersQueryKeys = createQueryKeys(EQueryKeys.CustomerQueryKeys, {
  getCustomersList: (counterpartyGUID: string, params: TCustomersListReqParams = {}) => ({
    queryKey: ['counterparties-customers-list-all', params, counterpartyGUID],
    queryFn: (): Promise<TCustomersListResData> => getCounterpartyCustomersListService(counterpartyGUID, params),
  }),
  getCustomerAccountsList: (counterpartyGUID: string, customerGUID: string) => ({
    queryKey: ['counterparties-customer-accounts-list', counterpartyGUID, customerGUID],
    queryFn: (): Promise<TCustomerAccountsListResData> =>
      getCustomerAccountsListService(counterpartyGUID, customerGUID),
  }),

  getCustomersList_MultiRole: (
    counterpartyGUID: string,
    branchGUID: string,
    params?: TCustomersListReqParams,
    hasAccessForAllBranches?: boolean,
  ) => ({
    queryKey: [
      'get-counterparties-customers-list-multi-role',
      params,
      counterpartyGUID,
      branchGUID,
      hasAccessForAllBranches
    ],
    queryFn: (): Promise<TCustomersListResData> => {
      if (hasAccessForAllBranches) {
        const redoParams = {
          ...params,
          ...(branchGUID ? { branch_guids: [branchGUID] } : null),
        }

        return getCounterpartyCustomersListService(counterpartyGUID, redoParams);
      }

      return counterpartyGetBranchCustomersService(counterpartyGUID, branchGUID, params);
    },
  }),
});
